module.exports = __webpack_public_path__ + "static/media/josip.346b1d37.png";